import React from 'react';

const SAMPLE_PRODUCTS = [
  { name: 'Classic Cotton Kurta', price: 2999, originalPrice: 4999, tag: 'SALE', image: null },
  { name: 'Silk Embroidered Saree', price: 8999, originalPrice: null, tag: null, image: null },
  { name: 'Designer Lehenga Set', price: 12999, originalPrice: 18999, tag: 'SALE', image: null },
  { name: 'Printed Palazzo Pants', price: 1499, originalPrice: 2499, tag: null, image: null },
  { name: 'Handloom Dupatta', price: 999, originalPrice: null, tag: 'NEW', image: null },
  { name: 'Embroidered Anarkali', price: 5999, originalPrice: 7999, tag: null, image: null },
];

const ProductCard = ({ product }) => (
  <div style={{
    borderRadius: '12px', overflow: 'hidden', background: '#fff',
    border: '1px solid #f0f0f0', cursor: 'default', transition: 'all 0.2s',
  }}>
    {/* Image placeholder */}
    <div style={{
      aspectRatio: '3/4', background: 'linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      position: 'relative', overflow: 'hidden',
    }}>
      <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="1.5">
        <rect x="3" y="3" width="18" height="18" rx="2" />
        <circle cx="8.5" cy="8.5" r="1.5" />
        <path d="M21 15l-5-5L5 21" />
      </svg>
      {product.tag && (
        <span style={{
          position: 'absolute', top: '8px', left: '8px',
          background: product.tag === 'SALE' ? '#ef4444' : '#111827',
          color: '#fff', fontSize: '9px', fontWeight: 700, padding: '3px 8px',
          borderRadius: '4px', letterSpacing: '0.05em',
        }}>{product.tag}</span>
      )}
    </div>
    {/* Info */}
    <div style={{ padding: '12px' }}>
      <p style={{
        fontSize: '13px', fontWeight: 500, color: '#374151',
        overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
        marginBottom: '6px',
      }}>{product.name}</p>
      <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
        <span style={{ fontSize: '14px', fontWeight: 600, color: '#111827' }}>
          {'\u20B9'}{product.price.toLocaleString()}
        </span>
        {product.originalPrice && (
          <>
            <span style={{ fontSize: '12px', color: '#9ca3af', textDecoration: 'line-through' }}>
              {'\u20B9'}{product.originalPrice.toLocaleString()}
            </span>
            <span style={{ fontSize: '10px', fontWeight: 600, color: '#ef4444' }}>
              {Math.round((1 - product.price / product.originalPrice) * 100)}% OFF
            </span>
          </>
        )}
      </div>
    </div>
  </div>
);

export default function ShopProductGridPreview({ attributes = {} }) {
  return (
    <div style={{ padding: '24px' }}>
      {/* Category pills */}
      <div style={{ display: 'flex', gap: '8px', marginBottom: '20px', flexWrap: 'wrap' }}>
        {['All', 'Kurtas', 'Sarees', 'Lehengas', 'Western'].map((cat, i) => (
          <span key={cat} style={{
            padding: '6px 16px', borderRadius: '20px', fontSize: '12px', fontWeight: 500,
            background: i === 0 ? '#111827' : '#f3f4f6',
            color: i === 0 ? '#fff' : '#6b7280',
            cursor: 'default',
          }}>{cat}</span>
        ))}
      </div>
      {/* Product grid */}
      <div style={{
        display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))',
        gap: '16px',
      }}>
        {SAMPLE_PRODUCTS.map((p, i) => <ProductCard key={i} product={p} />)}
      </div>
      {/* Sample results text */}
      <p style={{ textAlign: 'center', fontSize: '12px', color: '#9ca3af', marginTop: '20px' }}>
        Showing 6 of 24 products — Your actual products will appear here
      </p>
    </div>
  );
}
